import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { Tag, ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";

const PricingTeaser = () => {
  return (
    <section id="layers" className="relative py-20 overflow-hidden">
      <div className="container relative mx-auto px-6">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          className="text-center max-w-4xl mx-auto"
        >
          <div className="mb-4 inline-flex items-center gap-2 rounded-full border border-primary/30 bg-primary/10 px-4 py-1.5 text-sm font-medium text-primary">
            <Tag className="h-3.5 w-3.5" />
            Pricing
          </div>
          <h2 className="mb-4 text-3xl font-bold text-foreground md:text-4xl lg:text-5xl">
            Three layers. Start at{" "}
            <span className="text-primary">€0.02 per signal.</span>
          </h2>
          <p className="mx-auto max-w-3xl text-lg text-muted-foreground mb-8 md:whitespace-nowrap">
            Self-serve at Layer 1. Qualified access at Layer 2. Enterprise at Layer 3.
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
            <Button asChild variant="hero" size="lg" className="group">
              <Link to="/pricing">
                See full pricing
                <ArrowRight className="ml-1.5 h-4 w-4 transition-transform group-hover:translate-x-0.5" />
              </Link>
            </Button>
            <Button asChild size="lg" variant="outline" className="min-h-[44px] md:min-h-0">
              <a href="#calculator">Calculate your platform's cost</a>
            </Button>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default PricingTeaser;
